<template>
    <div v-if="product.length>0" class="row row-cols-1 row-cols-md-3 row-cols-lg-3 row-cols-xl-4 row-cols-xxl-4 col-mb-16 gx-3">

        <div class="col" v-for="(item,index) in product"  :key="index">

            <div class="product-card listStyle_1">
               <!--  <button class="wishListBtn added"></button> -->
                <router-link :to="`/product/${str_encode(item.id)}`" class="card-body heightAuto">
                    <div class="pro-img-block">
                        <div class="freeSampleTag" v-if="item.product.category.is_sample">
                            <img src="assets/images/freeSampleStar.svg" alt=""> <span>Free Samples</span>
                        </div>
                        <div v-lazy-container="{ selector: 'img' }">
                            <img :data-src="set_image(item.product.photo)" class="card-img-top pro-img"
                                 alt="product images" data-error="images/no_image.svg"
                                 data-loading="images/loading.gif">
                        </div>
                    </div>
                </router-link>
                    <div class="  finish-product">                       

                       <!--  <button class="btn btn-link" type="button" 
                                v-if="item.product.link_products.length>0">
                            {{ item.product.link_products.length }} Finishes
                        </button> -->
                        
                        
                            <VueSlickCarouselFinal
                            :slidesToShow="5"
                            :slidesToScroll="1"
                            :autoplay="true"
                            :autoplaySpeed="5000"
                            :infinite="true"
                            :dots="false"
                            :arrows="true"
                            :centerMode="false"
                            :cssEase="'linear'"
                            
                        >
                            <div v-for="(link_product,x ) in item.product.link_products"
                            v-if="item.product.link_products.length>0" :key="'ff'+x"><router-link class="" :to="`/product/${str_encode(item.id)}`"><img :src="set_image(link_product.photo)" :alt="link_product.name" > </router-link></div>

                            </VueSlickCarouselFinal>
                        
                        
                    </div>
                    <router-link :to="`/product/${str_encode(item.id)}`" class="card-body heightAuto">
                    <span class="pro-model"> <span class="fw-semibold">Brand:</span> <span>{{ item.product.description }}</span></span>
                    <span class="pro-short-desc pro-link fw-semibold">{{ item.product.name }}</span>
                    
                    <span class="font-14 mb-1" v-if="(item.width_size && (item.height_size || item.length_size) ) || item.pattern">
                                                                <span>Size:</span>
                                                                <span v-if="item.pattern">{{item.pattern}}</span>
                                                                <span v-else>{{item.width_size}} X
                                                                    {{item.product.category.unit == 'Box' ? item.height_size : item.length_size}}</span></span>
                                                                    <span class="pro-model sku"> <span>SKU:</span> <span>{{ item.product.sku }}</span></span>
                    <h6 class="pro-price">
                        <sup>$</sup>
                        <p class="amount">{{
                                CalculateProductSellPrice(item.price, item.discount, item.product_admin_markup_amount, item.contractor_products[0].markup, item.box_sqft, (item.product && item.product.category && item.product.category.unit) ? item.product && item.product.category && item.product.category.unit : '')|toCurrency
                            }}</p>
                        <sup>/{{
                                item.product && item.product.category && item.product.category.unit == 'Box' ? 'sq. ft.' : 'Piece'
                            }}</sup>
                    </h6>

                

                <div class="pro-shipping" v-if="showroomId && showroomId.basic_addon">
                    <span>
                        <span style="transform: rotateY(180deg);"><i class="fa fa-truck " aria-hidden="true"></i></span> FREE Shipping / Pickup</span>
                </div>
                    <div class="pro-shop-btn" style="justify-content: center;">
                        <button type="button" class="btn addToCartBtn btn-sm" @click.prevent="sync_cart(item,false)">Add to
                            Cart
                        </button>
                        <!-- <button type="button" @click.prevent="sync_cart(item,true)" class="btn btn-dark btn-sm">Buy Now</button> -->
                    </div>
                </router-link>
                <!-- <a href="#" class="stretched-link"></a> -->
            </div>
        </div>







    </div>

        <div class="col" v-else>
        <div class="row-cols-12  ">
            <h4 class="text-danger" v-if="beforesearch">&nbsp;</h4>
            <div class=" " v-else>
                <p> Search Help </p>
                <ul>
                    <li>Check your search for typos</li>
                    <li>Use more generic search terms</li>
                    <li> The product you're searching for may be discontinued or not yet on our site</li>
                </ul>            
            </div>
         </div>
         
        </div>



        


</template>
<script>
import VueSlickCarouselFinal from "vue-slick-carousel";

import {mapActions, mapGetters} from "vuex";
import { EventBus } from "../store/eventBus";

export default {
    props: ['product','beforesearch'],
    components: {
        VueSlickCarouselFinal,
    },
    computed: {
        ...mapGetters({
            showroomId: 'Common/MyItem',
        })
    },
    mounted() {
        let data = {}

        var token = localStorage.getItem('authToken') ? localStorage.getItem('authToken') : ''

        if (token !== '') {
            this.projectCreatRequest({
                showroom: this.showroomId.showroom,
                is_3d: false
            })
        }


    },

    methods: {
        ...mapActions("cart", ["getCartData", "addCartRequest", 'projectCreatRequest']),
        CalculateProductSellPrice(Price, Discount, ProductAdminMarkupAmount, ContractorMarkup, box_sqft = 0, unit = '') {
            Price = parseFloat(Price);
            Discount = parseFloat(Discount);
            ProductAdminMarkupAmount = parseFloat(ProductAdminMarkupAmount);
            ContractorMarkup = parseFloat(ContractorMarkup);
            let product_price = (Price - (Price * Discount / 100)) + ProductAdminMarkupAmount;
            let contractor_markup = product_price * ContractorMarkup / 100;
            //let admin_markup = ProductAdminMarkupAmount
            let sell_price = product_price + contractor_markup;
            //return sell_price.toFixed(2);

            return unit == 'Box' ? (sell_price / box_sqft) : sell_price;
        },
        generateUniqueSixDigitNumber() {
            let uniqueNumber = '';
            const existingNumbers = new Set();

            while (uniqueNumber.length !== 6) {
                uniqueNumber = Math.floor(100000 + Math.random() * 900000).toString();

                if (!existingNumbers.has(uniqueNumber)) {
                existingNumbers.add(uniqueNumber);
                } else {
                uniqueNumber = ''; // Reset the number if it's not unique
                }
            }

            return uniqueNumber;
        },

        sync_cart(item,checkout) {


            let loaderd = "";
            loaderd = this.$loading.show({
                container: this.$refs.search_tab
            });
            console.log("item======>",item);
            let cart_item = {}
            cart_item.id = item.id
            cart_item.qty = 1
            cart_item.price = item.price
            cart_item.final_price = item.final_price
            cart_item.item=item



            var project =localStorage.getItem('project');
            console.log("project==========>",project);
            console.log("herrerr");
            project=parseInt(project);

            let cart_id="cart-"+this.generateUniqueSixDigitNumber();
                if(!localStorage.getItem('project')){
                    console.log("NaN.............");

            // if(project){
                    if(localStorage.getItem('cart_id')){
                        cart_id=localStorage.getItem('cart_id');
                    }
                    localStorage.setItem("cart_id", cart_id);
                   cart_item.is_cart=true;
                }
                cart_item.project_id = project ? project : cart_id;
                this.addCartRequest(cart_item).then(() => {
                    
                    Swal.fire({
                    title: 'Item Added to Cart!',
                    imageUrl: this.set_image(item.product.photo), 
                    imageWidth: 100,
                    imageHeight: 100,
                    imageAlt: 'Product image',
                    showCancelButton: true,
                    confirmButtonText: 'Checkout Now',
                    cancelButtonText: 'Keep Shopping',
                    confirmButtonColor: '#497f75',
                    cancelButtonColor: '#aaa',
                    reverseButtons: true,
                    showCloseButton: true,
                    }).then((result) => {
                    if (result.isConfirmed) {
                        // Redirect to checkout page
                        this.$router.push({ name: 'Cart' });
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        // Close the alert and continue shopping
                        console.log('Continue shopping');
                    }
                    });
                    
                    loaderd.hide();
                })
                .catch(() => {
                    loaderd.hide();
                })
            // }else{

            //     let cart_items=localStorage.getItem('cart_item');
            //     if(cart_items){
            //         cart_items=JSON.parse(cart_items);
            //     }else{
            //         cart_items=[];
            //     }
            //     let found=false;
            //     cart_items.forEach(item => {
            //         if (item.id === cart_item.id) {
            //             item.qty+=cart_item.qty;
            //             found=true;
            //         }
            //     });
            //     if(!found) {
            //         cart_items.push(cart_item);
            //     }
            //     localStorage.setItem("cart_item", JSON.stringify(cart_items));
            //     loaderd.hide();
            // }
            // EventBus.$emit('cart-updated');
            if(checkout){
                this.$router.push('/cart');
            }


        },

        


    }
}
</script>

